import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { CategriesPosFetchAPI } from '../../../api/Paymentpost/CategoriesPos';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { Badge } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import './ModalEditIp.css'
const ModalCategoriesPrinter = ({ printer }) => {
    const [showModalCategoriasPrinter, setShowModalCategoriasPrinter] = useState(false)
    const [categories, setCategories] = useState([])
    const [eventHandle, setEventHandle] = useState(0)
    let token = localStorage.getItem("x-access-machine-token")
    console.log(printer);
    const getCategories = async () => {

        try {
            const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, token)
            setCategories(response.data.categories)
        } catch (err) {
            console.log(err);
        }
    }

    const deleteCategorie = async (category_id) => {
        try {
            let data = {
                "category_id": category_id,
                "printer_id": printer.printer_id
            }
            const response = await CategriesPosFetchAPI.DeleteCategories(data, token)
            ErrorAlert("", "Categoria eliminada con exito", "success")
            setEventHandle(1)
            console.log(response);
        } catch (err) {

            ErrorAlert("", "Ocurrio un error", "error")


            console.log(err);
        }
    }

    useEffect(() => {
        getCategories();
        setEventHandle(0)
    }, [eventHandle])


    const viewCategories = () => {
        const listCategories = categories.map((categorie) => (
            <>
                <li className="sp-catrow">
                    <span className="sp-catrow__name">{categorie.name}</span>
                    <button
                        className="sp-catrow__del"
                        onClick={async () => (deleteCategorie(categorie.category_id))}
                        title="Eliminar categoría"
                        type="button"
                    >
                        <i className="uil uil-trash-alt"></i>
                    </button>
                </li>
            </>
        ));

        return (listCategories)
    }



    return (
        <>


            <button className="sp-cfg__btn sp-cfg__btn--primary mt-2" onClick={() => (setShowModalCategoriasPrinter(true), getCategories())}>
                <i className="uil uil-eye"></i> Ver categorias
            </button>

            <Modal
                show={showModalCategoriasPrinter}
                onHide={() => setShowModalCategoriasPrinter(false)}
                size="sm-down"
                centered

            >
                <Modal.Body className="sp-cfgmini rounded-5">
                    <div className="sp-cfgmini__head">
                        <div className="sp-cfg__badge sp-cfg__badge--sm"><i className="uil uil-print"></i></div>
                        <h5 className="sp-cfgmini__title">{printer.printer_name}</h5>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setShowModalCategoriasPrinter(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <h3 className="sp-eip__subtitle"><i className="uil uil-list-ul"></i> Categorias asignadas</h3>

                    <div className="sp-catp__list">
                        <ListGroup as="ol" numbered>
                            {viewCategories()}
                        </ListGroup>
                    </div>

                    <div className="sp-cfgmini__acts">
                        <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => (setShowModalCategoriasPrinter(false))}>Cerrar</button>
                    </div>
                </Modal.Body>
            </Modal>



        </>
    )
}

export default ModalCategoriesPrinter